'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'backpack';
var width = 448;
var height = 512;
var aliases = [127890];
var unicode = 'f5d4';
var svgPathData = 'M320 80h-8V56C312 25.12 286.9 0 256 0H192C161.1 0 136 25.12 136 56V80H128c-70.75 0-128 57.25-128 128V448c0 35.38 28.62 64 64 64h320c35.38 0 64-28.62 64-64V208C448 137.2 390.8 80 320 80zM184 56C184 51.62 187.6 48 192 48h64c4.375 0 8 3.625 8 8V80h-80V56zM320 464H128v-64h192V464zM320 352H128v-32c0-17.62 14.38-32 32-32h128c17.62 0 32 14.38 32 32V352zM400 448c0 8.875-7.125 16-16 16h-16V320c0-44.13-35.88-80-80-80H160c-44.12 0-80 35.88-80 80v144H64c-8.875 0-16-7.125-16-16V208C48 163.9 83.88 128 128 128h192c44.13 0 80 35.88 80 80V448zM304 160H143.1C135.1 160 128 167.1 128 175.1V192c0 8.875 7.125 16 16 16h160C312.9 208 320 200.9 320 192V176C320 167.1 312.9 160 304 160z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBackpack = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;